var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mt-3 json-container",attrs:{"header":"JSON Data Preview"}},[_c('pre',{staticClass:"m-0 text-left"},[_vm._v(_vm._s(_vm.form1))])])
}
var staticRenderFns = []

export { render, staticRenderFns }